
import { AreaSeries, createChart, LayoutPanesOptions, ColorType, TimeChartOptions } from 'lightweight-charts';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { currencyFormatter, formatDate } from '../../../app/Helpers';


export const ChartComponent = (props: any) => {
    const [pair, setPair] = useState<any>(undefined)
    const [resolution, setResolution] = useState<any>(undefined)

    const [chart, setChart] = useState<any[] | undefined>(undefined)
    const [searchParams] = useSearchParams();

    const chartContainer = useRef<HTMLInputElement>(null);


    useEffect(() => {

        window.addEventListener("message", message => {
            try {
                var d = JSON.parse(message.data);
                if (d.pair) {
                    setPair(d.pair)

                }
                if (d.chart) {
                    setChart(JSON.parse(d.chart));
                    //(window as any).ReactNativeWebView.postMessage(JSON.parse(d.chart));
                }
                if (d.resolution) {
                    setResolution(d.resolution)
                }

            } catch { }
        });
    }, [])
    useEffect(
        () => {
            const lang = searchParams.get('lang');
            const isDark = searchParams.get('isDark') != "0";

            if (chart == undefined || pair == undefined || resolution == undefined || chart.length == 0) {
                return;
            }
            var isDownTrend = false;

            if (chart && chart.length > 1) {
                if (chart[0].c > chart[chart.length - 1].c) {
                    isDownTrend = true;
                }

            }
            const positiveColors = {
                topColor: 'rgba(38, 166, 154, 0.28)',   // soft teal-green fill
                bottomColor: 'rgba(38, 166, 154, 0.05)',
                lineColor: 'rgba(38, 166, 154, 1)',
            };

            // If price/trend is negative
            const negativeColors = {
                topColor: 'rgba(239, 83, 80, 0.28)',    // red tones
                bottomColor: 'rgba(239, 83, 80, 0.05)',
                lineColor: 'rgba(239, 83, 80, 1)',
            };

            if (chartContainer?.current == null || chartContainer?.current == undefined) {
                return
            }

            const chartLayout = createChart(chartContainer.current, {
                layout: {
                    textColor: isDark ? 'rgb(228, 226, 230)' : 'rgb(27, 27, 31)',
                    background: { type: ColorType.Solid, color: isDark ? 'rgb(27, 27, 31)' : 'rgb(254, 251, 255)' },

                },
                localization: {
                    priceFormatter: function (price: any) {

                        return currencyFormatter(price, { significantDigits: pair?.quoteCurrencyDecimalPlaces ?? 9 })
                    },
                },

                rightPriceScale: {
                    visible: false, borderVisible: false, autoScale: true,
                    entireTextOnly: false, scaleMargins: { bottom: 0, top: 0 },
                },

                timeScale: { visible: false, },
                crosshair: {
                    // hide the horizontal crosshair line
                    horzLine: {
                        visible: false,
                        labelVisible: false,
                    },
                    // hide the vertical crosshair label
                    vertLine: {
                        labelVisible: false,
                    },
                },
                // hide the grid lines
                grid: {
                    vertLines: {
                        visible: false,
                    },
                    horzLines: {
                        visible: false,
                    },
                },
                handleScale: {
                    axisPressedMouseMove: {
                        time: false,
                        price: false,
                    },
                    mouseWheel: false,
                    pinch: false,

                },
                handleScroll: {
                    mouseWheel: false,
                    pressedMouseMove: false,
                    horzTouchDrag: false,
                    vertTouchDrag: false
                },
            });


            const series = chartLayout.addSeries(AreaSeries, {
                topColor: isDownTrend ? negativeColors.topColor : positiveColors.topColor,
                bottomColor: isDownTrend ? negativeColors.bottomColor : positiveColors.bottomColor,
                lineColor: isDownTrend ? negativeColors.lineColor : positiveColors.lineColor,
                lineWidth: 2,

                crosshairMarkerVisible: true
            });
            window.addEventListener("message", message => {
                try {
                    var d = JSON.parse(message.data)
                    if (d.price) {
                        var isDown = false;
                        if (series && series.data().length > 1) {
                            if ((series.data()[0] as any).value > d.price) {
                                isDown = true;
                            }

                        }

                        series.update({
                            time: d.time, value: d.price,

                        })
                        series.applyOptions({
                            topColor: isDown ? negativeColors.topColor : positiveColors.topColor,
                            bottomColor: isDown ? negativeColors.bottomColor : positiveColors.bottomColor,
                            lineColor: isDown ? negativeColors.lineColor : positiveColors.lineColor,

                        })
                    }
                } catch { }
            });
            const tradingViewData = chart.map((d: any) => {
                const time = moment(d.fullDate).valueOf();  //new Date().getTime()
                return {
                    time: time,
                    value: d.c,
                };
            });

            // (window as any).ReactNativeWebView.postMessage(JSON.stringify(resolution));
            series.setData(tradingViewData as any);


            const toolTipWidth = 80;
            const toolTipHeight = 80;
            const toolTipMargin = 15;

            const t = chartContainer.current.querySelector('#chart-tooltip');
            if (t) {
                t.remove();
            }
            // Create and style the tooltip html element
            const toolTip = document.createElement('div');
            toolTip.id = 'chart-tooltip'; // Add an ID
            toolTip.style = `position: absolute; display: none; padding: 8px; box-sizing: border-box; font-size: 12px; text-align: left; z-index: 1000; top: 12px; left: 12px; pointer-events: none; border: 1px solid; border-radius: 2px;font-family: -apple-system, BlinkMacSystemFont, 'Trebuchet MS', Roboto, Ubuntu, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;`;
            toolTip.style.background = isDark ? 'rgb(27, 27, 31)' : 'rgb(254, 251, 255)';
            toolTip.style.color = isDark ? 'rgb(254, 251, 255)' : 'rgb(27, 27, 31)';
            toolTip.style.borderColor = isDownTrend ? negativeColors.topColor : positiveColors.topColor;
            chartContainer.current.appendChild(toolTip);

            // update tooltip
            chartLayout.subscribeCrosshairMove(param => {
                if (chartContainer.current)
                    if (
                        param.point === undefined ||
                        !param.time ||
                        param.point.x < 0 ||
                        param.point.x > chartContainer.current.clientWidth ||
                        param.point.y < 0 ||
                        param.point.y > chartContainer.current.clientHeight
                    ) {
                        toolTip.style.display = 'none';
                    } else {
                        // time will be in the same format that we supplied to setData.
                        // thus it will be YYYY-MM-DD
                        const dateStr = param.time;
                        toolTip.style.display = 'block';
                        const data = param.seriesData.get(series) as any;
                        const price = data?.value !== undefined ? data.value : data?.value;
                        toolTip.innerHTML = `<div style="color: ${isDark ? 'rgb(228, 226, 230)' : 'rgb(27, 27, 31)'}">${pair?.name}</div><div style="font-size: 24px; margin: 4px 0px; color: ${isDark ? 'rgb(228, 226, 230)' : 'rgb(27, 27, 31)'}">
            ${currencyFormatter(price, { significantDigits: pair?.quoteCurrencyDecimalPlaces ?? 9 })}
            </div><div style="color: ${isDark ? 'rgb(228, 226, 230)' : 'rgb(27, 27, 31)'}">
            ${formatDate(new Date(Number(dateStr)))}
            </div>`;

                        const y = param.point.y;
                        let left = param.point.x + toolTipMargin;
                        if (left > chartContainer.current.clientWidth - toolTipWidth) {
                            left = param.point.x - toolTipMargin - toolTipWidth;
                        }

                        let top = y + toolTipMargin;
                        if (top > chartContainer.current.clientHeight - toolTipHeight) {
                            top = y - toolTipHeight - toolTipMargin;
                        }
                        toolTip.style.left = left + 'px';
                        toolTip.style.top = top + 'px';
                    }
            });


            chartLayout.timeScale().fitContent();
            // optional: pad last point by +1 day to fully touch edge
            return () => {
                chartLayout.remove();
            };
        },
        [chart]
    );
    // /position: absolute; width: 100%; height: 100%;
    return (<div
        style={{ position: 'absolute', width: "100%", height: "100%", background: searchParams.get('isDark') != "0" ? 'rgb(27, 27, 31)' : 'rgb(254, 251, 255)'}}
        ref={chartContainer}
    />);
};


export function LightweightChart(props: any) {
    return (
        <ChartComponent {...props} ></ChartComponent>
    );
}




/*import { DetailsListLayoutMode, IColumn, Selection, Link, IDragDropContext, IDragDropEvents, IListProps, SelectionMode, Text, CommandBar, ICommandBarItemProps, IButtonProps, IPersonaSharedProps, Persona, PersonaSize, getTheme, SearchBox, Stack, Callout, DirectionalHint, IconButton, TagPicker, IBasePickerSuggestionsProps, IInputProps, ITag, TagItemSuggestion, FontIcon, TagItem, ISuggestionsProps, ISuggestionItemProps, ISuggestionModel, TextField, ITextFieldProps, Label, Overlay, ComboBox, Dropdown, PrimaryButton, DefaultButton, SpinButton, IContextualMenuProps, ShimmeredDetailsList, FocusZone, FocusZoneTabbableElements, FontWeights, Spinner, SpinnerSize, memoizeFunction, CommandBarButton, IDropdownOption, IStackComponent, ISearchBoxProps, IPeoplePickerItemSelectedProps, PeoplePickerItem, ValidationState, NormalPeoplePicker, IPersonaProps, IPickerItemProps, TooltipHost, DialogFooter, CheckboxVisibility, ConstrainMode, StackItem } from "@fluentui/react"
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch } from "../../../app/Hooks"
import { APIResponse, ApiMessage, SARAFA_API_URL, getHeaders, getSession } from "../../../app/SarafaAPI"
import { currencyFormatter, formatDate, printComponent, normalizeKey, timestampToDate, generateTradingViewSession } from "../../../app/Helpers"
import { TableState } from "../../common/Table/TableSate"
import { useNavigate, useSearchParams } from "react-router-dom"
import { PageProps } from "../PageProps"
import {
    widget,
    ChartingLibraryWidgetOptions,
    LanguageCode,
    ResolutionString,
    ChartingLibraryFeatureset,
    IBasicDataFeed,
    CustomTimezoneId,
    IChartingLibraryWidget,
} from '../../../charting_library';
import * as React from 'react';
import { getCurrentLanguage } from '../../../app/Helpers';
import { useAppSelector } from '../../../app/Hooks';
import { useParams } from 'react-router-dom';
import { getPage } from "../../../app/Pages"
import { GetCurrencyExchangeRatesReportRequest, GetCurrencyExchangeRatesReportResponse } from "../../../repository/Sarafa/report_pb"
import { GetCurrencyPairsRequest, GetCurrencyPairsResponse } from "../../../repository/Sarafa/currency_pair_pb"
import { Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb"
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb"
import moment from "moment"
import { dismissMessage, getItems, getReport, reset } from "../AdvancedChart/AdvancedChartPageSlice"
import { CurrencyForm } from "../../../app/Enums"
import { SessionExpiredDialog } from "../../common/SessionExpiredDialog/SessionExpiredDialog"
import { Message } from "../../common/Message/Message"
import { LocalStorageSaveLoadAdapter } from "../Storage"

export interface ChartContainerProps {
    symbol: ChartingLibraryWidgetOptions['symbol'];
    interval: ChartingLibraryWidgetOptions['interval'];

    // BEWARE: no trailing slash is expected in feed URL
    datafeedUrl: string;
    libraryPath: ChartingLibraryWidgetOptions['library_path'];
    chartsStorageUrl: ChartingLibraryWidgetOptions['charts_storage_url'];
    chartsStorageApiVersion: ChartingLibraryWidgetOptions['charts_storage_api_version'];
    clientId: ChartingLibraryWidgetOptions['client_id'];
    userId: ChartingLibraryWidgetOptions['user_id'];
    fullscreen: ChartingLibraryWidgetOptions['fullscreen'];
    autosize: ChartingLibraryWidgetOptions['autosize'];
    studiesOverrides: ChartingLibraryWidgetOptions['studies_overrides'];
    container: ChartingLibraryWidgetOptions['container'];
}
let count: number = 0;



export const LightweightChart: React.FunctionComponent<PageProps> = (props) => {
    const [searchParams] = useSearchParams();
    const lang = searchParams.get('lang');
    const isDark = searchParams.get('isDark');
    const [pair, setPair] = useState<any>(undefined)
    const [resolution, setResolution] = useState<any>(undefined)
    const [chart, setChart] = useState<any>(undefined)



    const chartContainerRef = useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>;
    const disabled_features: ChartingLibraryFeatureset[] = []
    const disabled_features_mobile: ChartingLibraryFeatureset[] = [
        "header_widget",
        "header_symbol_search",
        "header_chart_type",
        "header_compare",
        "header_resolutions",
        "header_indicators",
        "header_settings",
        "header_saveload",
        "header_undo_redo",
        "header_fullscreen_button",
        "header_quick_search",
        "timeframes_toolbar",
        "control_bar",
        "left_toolbar",
        "symbol_info",
        "legend_widget",
        "legend_context_menu",
        "edit_buttons_in_legend",
        "delete_button_in_legend",
        "format_button_in_legend",
        "show_hide_button_in_legend",
        "legend_inplace_edit",
        "scales_context_menu",
        "pane_context_menu",
        "context_menus",
        "go_to_date",
        "chart_style_hilo",
        "chart_style_hilo_last_price",
        "show_symbol_logo_in_legend",
        "show_symbol_logos",
        "show_exchange_logos",
        "items_favoriting",
        "timeframes_toolbar",
        "timezone_menu",
        "use_symbol_name_for_header_toolbar",
        "move_logo_to_main_pane",
        "adaptive_logo",
        "display_legend_on_all_charts",
        "display_market_status",
        "chart_property_page_scales",
        "chart_property_page_right_margin_editor",
        "property_pages",
        "hide_image_invalid_symbol",
        "hide_last_na_study_output",
        "hide_left_toolbar_by_default",
        "hide_object_tree_and_price_scale_exchange_label",
        "hide_resolution_in_legend",
        "hide_unresolved_symbols_in_legend",
        "remove_library_container_border",
        "snapshot_trading_drawings",
        "study_templates",
        "chart_template_storage",
        "show_dom_first_time",
        "chart_property_page_trading",
        // Behavior / interactions
        "chart_zoom",
        "chart_scroll",
        "mouse_wheel_scale",
        "mouse_wheel_scroll",
        "pinch_scale",
        "pressed_mouse_move_scroll",
        "axis_pressed_mouse_move_scale",
        "horz_touch_drag_scroll",
        "vert_touch_drag_scroll",
        "long_press_floating_tooltip",
        "inactivity_gaps",
        "shift_visible_range_on_new_bar",
        "right_bar_stays_on_scroll",
        "fix_left_edge",
        "cropped_tick_marks",
        "disable_pulse_animation",
        "disable_resolution_rebuild",
        "end_of_period_timescale_marks",
        "pre_post_market_sessions",
        "auto_enable_symbol_labels",
        "seconds_resolution",
        "tick_resolution",
        "two_character_bar_marks_labels",
        "uppercase_instrument_names",
        "use_last_visible_bar_value_in_legend",
        "disable_legend_inplace_resolution_change",
        "disable_legend_inplace_symbol_change",
        "studies_extend_time_scale",
        "secondary_series_extend_time_scale",
        "charting_library_debug_mode",
        "request_only_visible_range_on_reset",
        "constraint_dialogs_movement",
        "insert_indicator_dialog_shortcut",
        "disable_legend_inplace_resolution_change",
        "disable_legend_inplace_symbol_change",
        "use_na_string_for_not_available_values",
        "volume_force_overlay",
        "create_volume_indicator_by_default",
        "create_volume_indicator_by_default_once",
    ]




    const defaultProps: Omit<ChartContainerProps, 'container'> = {
        symbol: 'USDLYD',
        interval: '15' as ResolutionString,
        datafeedUrl: 'https://localhost:7166/api/trading-view/udf',
        libraryPath: '/charting_library/',
        chartsStorageUrl: 'https://saveload.tradingview.com',
        chartsStorageApiVersion: '1.1',
        clientId: 'tradingview.com',
        userId: 'public_user_id',
        fullscreen: false,
        autosize: true,
        studiesOverrides: {},

    };



    const DataFeed: IBasicDataFeed = {

        onReady: (callback: any) => {
            setTimeout(() => callback({
                // Represents the resolutions for bars supported by your datafeed
                supported_resolutions: ["1S", "1", "15", "30", "60", "240", "1D", "1W", "1M"],
                supports_search: false,
                supports_group_request: false,
                supports_marks: false,
                supports_timescale_marks: false,
                supports_time: false,

            }));
        },

        searchSymbols: async (
            userInput: any,
            exchange: any,
            symbolType: any,
            onResultReadyCallback: any,
        ) => {


            setTimeout(() => {

                if (pair) {
                    onResultReadyCallback({
                        symbol: (pair.baseCurrencyCode + "" + pair.quoteCurrencyCode),
                        full_name: "1:" + (pair.baseCurrencyCode + "" + pair.quoteCurrencyCode), // e.g. BTCE:BTCUSD
                        description: pair?.name,
                        exchange: "1",
                        ticker: pair.id,
                        logo_urls: ["" + pair.iconSource],
                        type: pair.categoryId

                    });
                } else {
                    onResultReadyCallback({


                    });
                }
            }, 0);

        },

        resolveSymbol: async (
            symbolName: any,
            onSymbolResolvedCallback: any,
            onResolveErrorCallback: any,
            extension: any
        ) => {

            if (pair) {
                const symbolInfo = {
                    ticker: "1:" + (pair.baseCurrencyCode + "" + pair.quoteCurrencyCode),
                    original_unit_id: pair.name,
                    name: (pair.baseCurrencyCode + "" + pair.quoteCurrencyCode),
                    description: pair.name,
                    type: pair.categoryId,
                    timezone: "Europe/Rome",
                    session: generateTradingViewSession(pair.tradingDays, pair.tradingHours, pair.openingDay),
                    exchange: "1",
                    minmov: 1,
                    pricescale: Number("1".padEnd(pair.quoteCurrencyDecimalPlaces + 1, '0')),
                    has_intraday: true,

                    has_daily: true,
                    has_weekly_and_monthly: true,

                    visible_plots_set: 'ohlcv',
                    supported_resolutions: ["1S", "1", "15", "30", "60", "240", "1D", "1W", "1M"],
                    volume_precision: pair.baseCurrencyDecimalPlaces,
                    data_status: pair.isMarketOpen ? 'streaming' : 'endofday',
                    delay: pair.isMarketOpen ? 0 : -1,
                    logo_urls: ["" + pair.iconSource]
                };

                setTimeout(() => { onSymbolResolvedCallback(symbolInfo); }, 0);
            } else {
                setTimeout(() => { onSymbolResolvedCallback(undefined); }, 0);

            }

        },

        getBars: async (symbolInfo: any, resolution: any, periodParams: any, onHistoryCallback: any, onErrorCallback: any) => {
            // Example dump data for TradingView


            if (count == 1) {
                onHistoryCallback([], {
                    noData: true,
                });
                return;

            } else {
                count++;

                const tradingViewData = chart.map((d: any) => {
                    const time = moment(d.fullDate).valueOf();  //new Date().getTime()

                    return {
                        time: time,
                        open: d.o,
                        high: d.h,
                        low: d.l,
                        close: d.c,
                        volume: d.vb
                    };
                });
                //const bars = generateDummyOHLC(100, 100);

                // Return bars
                onHistoryCallback(tradingViewData, { noData: false });
            }


        },


        subscribeBars(symbolInfo, resolution, onTick, listenerGuid, onResetCacheNeededCallback) {

            window.addEventListener("message", message => {
                try {
                    var d = JSON.parse(message.data)

                    if (d.price) {
                        onTick({
                            time: d.time,
                            open: Number(d.price).valueOf(),
                            high: Number(d.price).valueOf(),
                            low: Number(d.price).valueOf(),
                            close: Number(d.price).valueOf(),
                            volume: 0
                        })
                    }
                } catch { }
            });
        },
        unsubscribeBars(listenerGuid) {

        },
    };




    useEffect(() => {
        window.addEventListener("message", message => {
            try {
                var d = JSON.parse(message.data);

                if (d.pair) {
                    setPair(d.pair)

                }
                if (d.chart) {
                    setChart(JSON.parse(d.chart));
                    count = 0
                    //(window as any).ReactNativeWebView.postMessage(JSON.parse(d.chart));
                }
                if (d.resolution) {
                    setResolution(d.resolution)
                }


            } catch { }
        });
    }, [])

    const [tvWidget, setTvWidget] = useState<IChartingLibraryWidget | undefined>(undefined)



    useEffect(() => {
        if (pair != undefined && resolution != undefined && chart != undefined) {

            const widgetOptions: ChartingLibraryWidgetOptions = {
                datafeed: DataFeed,
                interval: resolution as ChartingLibraryWidgetOptions['interval'],
                container: chartContainerRef.current,
                library_path: defaultProps.libraryPath as string,
                locale: searchParams.get('local') as LanguageCode ?? "ar" as LanguageCode,
                charts_storage_url: defaultProps.chartsStorageUrl,
                charts_storage_api_version: defaultProps.chartsStorageApiVersion,
                client_id: defaultProps.clientId,
                user_id: defaultProps.userId,
                fullscreen: defaultProps.fullscreen,
                autosize: defaultProps.autosize,
                studies_overrides: defaultProps.studiesOverrides,
                enabled_features: [] as ChartingLibraryFeatureset[],
                disabled_features: disabled_features_mobile,

                debug: false,
                timezone: "Europe/Rome",
                theme: searchParams.get('isDark') == "1" ? "dark" : 'light',

                symbol: "TEST",


            }

            const tvWidget = new widget(widgetOptions);
            tvWidget?.onChartReady(() => {
                tvWidget.changeTheme(searchParams.get('isDark') == "1" ? "dark" : 'light');
                const newOverrides = {
                    "symbolWatermarkProperties.visible": false,
                    "paneProperties.legendProperties.showLegend": false,
                    "paneProperties.legendProperties.showStudyArguments": false,
                    "paneProperties.legendProperties.showStudyTitles": false,
                    "paneProperties.legendProperties.showStudyValues": false,
                    "paneProperties.legendProperties.showSeriesTitle": false,
                    "paneProperties.legendProperties.showSeriesOHLC": false,


                };
                tvWidget.applyOverrides(newOverrides)
                // Apply new overrides to active chart
                const achart = tvWidget.activeChart();

                achart.setChartType(3);
                const bars = chart
                const times = bars.map((bar: any) => {
                    const time = moment(bar.fullDate).valueOf();  //new Date().getTime()
                    return time

                });
                const first = Math.min(...times);
                const last = Math.max(...times);

                // Set the visible range to cover all bars
                achart.setVisibleRange({ from: first / 1000, to: last / 1000 });

            });
            setTvWidget(tvWidget)
        }
    }, [pair]);



    function generateDummyOHLC(startPrice = 100, numBars = 100) {
        const data = [];
        let lastClose = startPrice;
        const startDate = new Date('2024-10-01');

        for (let i = 0; i < numBars; i++) {
            // increment date by 1 day
            const time = new Date(startDate);
            time.setDate(startDate.getDate() + i);

            // generate some random OHLC around lastClose
            const open = lastClose + (Math.random() - 0.5) * 4;
            const high = open + Math.random() * 5;
            const low = open - Math.random() * 5;
            const close = low + Math.random() * (high - low);

            data.push({
                time: time.getTime(),
                open: Number(open.toFixed(2)).valueOf(),
                high: Number(high.toFixed(2)).valueOf(),
                low: Number(low.toFixed(2)).valueOf(),
                close: Number(close.toFixed(2)).valueOf(),
                volume: 0
            });

            lastClose = close; // next bar starts from this close
        }

        return data;
    }

    return <div
        ref={chartContainerRef}
        className={'TVChartContainer'}
        style={{ height: '100%' }}
    />
}




*/